import { createApp } from 'vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/finetuning.css';
import './assets/css/chat.css';
import App from './App.vue';

createApp(App).mount('#cemix-bot-app');

